import authType from '@/config/authType';
const filterItems = [
  { label: '角色名称', model: 'roleName', type: 'input', span: 6 },
  {
    type: 'select',
    label: '状态',
    model: 'roleStatus',
    options: [
      { name: '全部', value: -1 },
      { name: '启用', value: 1 },
      { name: '禁用', value: 0 }
    ],
    fun: 'selectChange',
    span: 6
  },
  { type: 'select', label: '应用系统', span: 6, model: 'appId', options: [] },
  {
    type: 'button',
    span: 6,
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo' }
    ]
  }
];
const getColumnsMap = (methods) => {
  return {
    // id: {
    //   title: 'id',
    //   key: 'id',
    //   width: 300,
    //   ellipsis: true,
    //   tooltip: true
    // },
    roleName: {
      title: '角色名称',
      key: 'roleName',
      width: 120,
      ellipsis: true,
      tooltip: true
    },
    remark: {
      title: '角色描述',
      key: 'remark',
      minWidth: 300,
      ellipsis: true,
      tooltip: true
    },
    appName: {
      title: '应用系统',
      key: 'appName',
      width: 120,
      ellipsis: true,
      tooltip: true
    },
    roleStatus: {
      title: '状态',
      key: 'roleStatus',
      width: 100,
      ellipsis: true,
      tooltip: true,
      align: 'center',
      render: (h, params) => {
        const { row } = params;
        return h('Tag', row.roleStatus == 0 ? { props: { color: 'volcano' } } : { props: { color: 'green' } }, row.roleStatus == 0 ? '禁用' : '启用');
      }
    },
    action: {
      title: '操作',
      key: 'action',
      minWidth: 160,
      ellipsis: true,
      tooltip: true,
      fixed: 'right',
      render: (h, params) => {
        const { row } = params;
        const buttonArr = [];
        buttonArr.push(
          h(
            'CustomButton',
            {
              props: { type: 'warning', size: 'small', permissionCode: authType.character.roleAuth },
              style: { margin: '4px' },
              on: {
                click: () => {
                  // this.setPermission(row);
                  methods.actAuthBtnClick(row);
                }
              }
            },
            '角色授权'
          ),
          h(
            'CustomButton',
            {
              props: { type: 'success', size: 'small', permissionCode: authType.character.userAuth },
              style: { margin: '4px' },
              on: {
                click: () => {
                  // this.openPersonSettingModal(row);
                  methods.userButtonClick(row);
                }
              }
            },
            '添加用户'
          ),
          h(
            'CustomButton',
            {
              props: { type: 'success', size: 'small', permissionCode: authType.character.editRowAuth },
              style: { margin: '4px' },
              on: {
                click: () => {
                  // this.editRole(row);
                  methods.editBtnClick(row);
                }
              }
            },
            '编辑'
          ),
          h(
            'CustomButton',
            {
              props: { type: 'error', size: 'small', permissionCode: authType.character.deleteRowAuth },
              style: { margin: '4px' },
              on: {
                click: () => {
                  // this.deleteCharactor(row);
                  methods.deleteBtnClick(row);
                }
              }
            },
            '删除'
          )
        );
        return h('div', { style: { 'text-align': 'left' } }, buttonArr);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};

export { filterItems, getColumns };
